<freud-loader
	class="loading"
	*ngIf="unifiedPromptuary.isLoading"
	size="lg"
	[bgColor]="false"
></freud-loader>

<div *ngIf="!unifiedPromptuary.isLoading && unifiedPromptuary.isPromptuaryCreated">
	<promptuary-view
		*ngIf="unifiedPromptuary.promptuaryMode === 'view'"
		[promptuary]="promptuary"
		[appointmentId]="appointmentId"
		[clientId]="clientId"
		[psychotherapist]="psychotherapist"
		[psychologist]="psychologist"
		[isAssistanceJourney]="isAssistanceJourney"
		[firstName]="firstName"
		(pageLoaded)="stopLoader()"
	></promptuary-view>

	<promptuary-form-crm
		[from]="from"
		[mainType]="mainType"
		*ngIf="unifiedPromptuary.promptuaryMode === 'manage'"
		[appointmentId]="appointmentId"
		[clientId]="clientId"
		[promptuary]="promptuary"
		[cachedICD]="promptuary ? promptuary.icd10 : []"
		(pageLoaded)="stopLoader()"
		[isAssistanceJourney]="isAssistanceJourney"
		(savedPromptuary)="updateState()"
	></promptuary-form-crm>
</div>
